import React from 'react';
import { Button } from './styles';
import { FaGoogle } from 'react-icons/fa';

const GoogleAuthButton: React.FC = () => {
  const handleGoogleLogin = () => {
    const baseUrl = process.env.REACT_APP_API_URL?.replace(/\/$/, '') || '';
    window.location.href = `${baseUrl}/api/auth/google/redirect?type=inquilino`;
  };

  return (
    <Button onClick={handleGoogleLogin}>
      <FaGoogle />
      <span>Continuar com Google</span>
    </Button>
  );
};

export default GoogleAuthButton;
